// extracted by mini-css-extract-plugin
module.exports = {"root":"_253808","icon":"_6d5835","ratingNumber":"_73adac"};